import React, { Fragment } from 'react';
import { Cog6ToothIcon } from '@heroicons/react/24/solid';
import { Menu, Transition } from '@headlessui/react';
import isMobileApp from 'utils/isMobileApp';

// const exampleItems = [
//   {
//     mobileAction: ()=>{},            // optional, if not present defaults to webAction
//     webAction: ()=>{} -OR- '',       // accepts function or string. If string, it acts as an href.
//     name: '',
//     webOnly: boolean;                // If true, only appears if not on the mobile app.
//   }
// ]

export default function CogMenu( { children, items, className = ''} 
: 
{ children?: React.ReactNode; items:any, className?:string } ){
  return (
    <Menu
      as="div"
      className={"flex items-center justify-center relative group transition rounded hover:shadow-inner hover:bg-slate-50 px-1 "+className}
    >
      <Menu.Button className="">
        <Cog6ToothIcon className="h-5 w-5 text-slate-500 cursor-pointer" />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="origin-top-right absolute top-full right-0 mt-2 rounded shadow-blue-lg border border-slate-300 bg-white focus:outline-none z-[99] w-36">
          {items.map((item, index) => {
            return (
              <Menu.Item key={index}>
                {item.mobileAction && isMobileApp()
                  ? <button className='block px-4 py-3 text-sm text-slate-700 w-full text-right rounded hover:bg-slate-100' onClick={item.mobileAction}>{item.name}</button>
                  : typeof item.webAction === 'string' 
                  ? <a href={item.webAction} className='block px-4 py-3 text-sm text-slate-700 w-full text-right rounded hover:bg-slate-100'>{item.name}</a>
                  : <button className='block px-4 py-3 text-sm text-slate-700 w-full text-right rounded hover:bg-slate-100' onClick={item.webAction}>{item.name}</button>
                }
              </Menu.Item>
            );
          })}
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
